import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, ArrowLeft, Clock } from 'lucide-react';
import { Button } from '../components/ui/button';

export const ContactPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-rose-50/50 to-white">
      <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
        <div className="container mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="text-2xl font-bold text-[#7d1f3d]">
              CurveeForYou
            </Link>
            <Link to="/">
              <Button variant="outline" className="border-[#7d1f3d] text-[#7d1f3d] hover:bg-[#7d1f3d] hover:text-white">
                <ArrowLeft className="w-4 h-4 mr-2" />
                Back to Shop
              </Button>
            </Link>
          </div>
        </div>
      </header>

      <main className="container mx-auto px-6 py-16 max-w-4xl">
        <h1 className="text-5xl font-bold text-[#7d1f3d] mb-6">Contact Us</h1>
        <p className="text-xl text-gray-600 mb-12">We&apos;re here to help!</p>

        <div className="space-y-8">
          <div className="bg-white border-2 border-gray-100 rounded-xl p-8 shadow-md">
            <div className="flex items-start gap-4 mb-6">
              <div className="bg-[#7d1f3d]/10 p-3 rounded-lg">
                <Mail className="w-6 h-6 text-[#7d1f3d]" />
              </div>
              <div>
                <h2 className="text-2xl font-bold text-[#7d1f3d] mb-3">Customer Service Email</h2>
                <p className="text-gray-600 mb-4">
                  For questions about orders, sizing, shipping, returns, or product information, please email us at:
                </p>
                <a 
                  href="mailto:info@curveeforyou.com" 
                  className="text-2xl font-semibold text-[#7d1f3d] hover:text-[#9d2f4d] transition-colors"
                >
                  info@curveeforyou.com
                </a>
              </div>
            </div>
          </div>

          <div className="bg-white border-2 border-gray-100 rounded-xl p-8 shadow-md">
            <div className="flex items-start gap-4">
              <div className="bg-[#7d1f3d]/10 p-3 rounded-lg">
                <Clock className="w-6 h-6 text-[#7d1f3d]" />
              </div>
              <div>
                <h2 className="text-2xl font-bold text-[#7d1f3d] mb-3">Response Time</h2>
                <p className="text-gray-600">
                  We typically respond to all customer service inquiries within 24 hours during business days (Monday - Friday, 9 AM - 5 PM EST).
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white border-2 border-gray-100 rounded-xl p-8 shadow-md">
            <h2 className="text-2xl font-bold text-[#7d1f3d] mb-4">What to Include in Your Message</h2>
            <p className="text-gray-600 mb-4">To help us assist you quickly, please include:</p>
            <ul className="space-y-2 text-gray-600">
              <li>• Your order number (if applicable)</li>
              <li>• A brief description of your question or concern</li>
              <li>• Your preferred contact method</li>
            </ul>
          </div>

          <div className="bg-gradient-to-br from-[#7d1f3d] to-[#9d2f4d] text-white rounded-2xl p-8">
            <h3 className="text-2xl font-bold mb-4">Before You Contact Us</h3>
            <p className="text-lg opacity-90 mb-4">You might find your answer faster in our FAQ or policy pages:</p>
            <div className="flex flex-wrap gap-3">
              <Link to="/faq">
                <Button variant="outline" className="border-white text-white hover:bg-white hover:text-[#7d1f3d]">
                  View FAQ
                </Button>
              </Link>
              <Link to="/shipping">
                <Button variant="outline" className="border-white text-white hover:bg-white hover:text-[#7d1f3d]">
                  Shipping Info
                </Button>
              </Link>
              <Link to="/returns">
                <Button variant="outline" className="border-white text-white hover:bg-white hover:text-[#7d1f3d]">
                  Returns Policy
                </Button>
              </Link>
              <Link to="/size-guide">
                <Button variant="outline" className="border-white text-white hover:bg-white hover:text-[#7d1f3d]">
                  Size Guide
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </main>

      <footer className="bg-[#7d1f3d] text-white py-8 mt-16">
        <div className="container mx-auto px-6 text-center">
          <div className="flex flex-wrap justify-center gap-6 mb-4">
            <Link to="/faq" className="hover:text-[#d4af37] transition-colors">FAQ</Link>
            <Link to="/shipping" className="hover:text-[#d4af37] transition-colors">Shipping</Link>
            <Link to="/returns" className="hover:text-[#d4af37] transition-colors">Returns</Link>
            <Link to="/size-guide" className="hover:text-[#d4af37] transition-colors">Size Guide</Link>
            <Link to="/contact" className="hover:text-[#d4af37] transition-colors">Contact</Link>
          </div>
          <div className="text-sm opacity-90 mb-3 leading-relaxed">
            <p className="font-semibold mb-1">CurveeForYou</p>
            <p>1209 Mountain Road Place Northeast, Suite N</p>
            <p>Albuquerque, NM 87110, United States</p>
            <p className="mt-2">
              <a href="tel:+18002985173" className="hover:text-[#d4af37] transition-colors">Tel: 800 298 5173</a>
              {' · '}
              <a href="mailto:info@curveeforyou.com" className="hover:text-[#d4af37] transition-colors">info@curveeforyou.com</a>
            </p>
          </div>
          <p className="text-sm opacity-80">© 2025 CurveeForYou. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};
